var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInformationCircleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9.818,
    height: 9,
    viewBox: "0 0 9.818 9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "iconmonstr-info-9",
    d: "M4.909,1C2.316,1,0,2.729,0,5.094a3.607,3.607,0,0,0,.837,2.3A6.428,6.428,0,0,1,.022,10,11.784,11.784,0,0,0,3.286,8.962c3.778.919,6.532-1.393,6.532-3.869C9.818,2.716,7.486,1,4.909,1Zm.409,6.136H4.5V4.682h.818Zm-.409-3.17a.511.511,0,1,1,.511-.511A.512.512,0,0,1,4.909,3.966Z",
    transform: "translate(0 -1)",
    fill: "#7f8093"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformationCircleIcon);
export default __webpack_public_path__ + "static/media/Information-circle-icon.8f9a34e95d028a7c836fce550f4fffe5.svg";
export { ForwardRef as ReactComponent };